const MODULE_NAME = 'login';

const LoginSelector = {
    token: (state) => state[MODULE_NAME].token,
};
export default LoginSelector;
